export const HEADER_HEIGHT: number = 84;
